import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const LABEL = { NEW: "New", QUALIFICATION: "Qualification", QUALIFIED: "Qualified", AI_PRESENTATION: "AI Presentation", DESIGNER_MEETING: "Designer Meeting", BOOKING_PENDING: "Booking Pending", BOOKED: "Booked" };

export function CRMDashboard() {
  const [d, setD] = useState(null);
  const load = () => api.get("/crm/dashboard").then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const complete = async (id) => { try { await api.post(`/followups/${id}/complete`); load(); } catch {} };
  if (!d) return <div className="text-sm text-neutral-400 py-6">Loading…</div>;
  const max = Math.max(1, ...d.funnel.map((f) => f.count));
  const fu = d.followups || { overdue: 0, due_today: 0, overdue_list: [] };
  const kpis = [
    ["New Leads", d.kpis.new_leads], ["Qualified", d.kpis.qualified], ["Designer Meetings", d.kpis.designer_meetings],
    ["Booking Pending", d.kpis.booking_pending], ["Booked", d.kpis.booked], ["Lost", d.kpis.lost],
    ["Total", d.kpis.total], ["Conversion", `${d.kpis.conversion_rate}%`],
  ];
  return (
    <div>
      {(fu.overdue > 0 || fu.due_today > 0) && (
        <div className="mb-5 rounded-lg border border-[#F5691C]/40 bg-[#FDF0E7] p-4" data-testid="crm-followup-alerts">
          <div className="flex items-center gap-2 mb-2"><span className="text-sm font-semibold text-[#D65A10]">Follow-ups need attention</span>
            <span className="mono text-xs bg-[#F5691C] text-white rounded-full px-2 py-0.5">{fu.overdue} overdue</span>
            <span className="mono text-xs bg-white border border-[#D7C6A9] rounded-full px-2 py-0.5">{fu.due_today} due today</span>
          </div>
          <div className="space-y-1.5">
            {fu.overdue_list.map((f) => (
              <div key={f.id} data-testid={`crm-followup-${f.id}`} className="flex items-center justify-between text-sm bg-white rounded-md px-3 py-2 border border-[#E3DAC8]">
                <span className="text-neutral-800">{f.lead_name} · <span className="text-neutral-500">{f.follow_up_type}</span> · <span className="mono text-xs text-red-600">due {f.due_at.slice(0, 10)}</span></span>
                <button onClick={() => complete(f.id)} data-testid={`crm-followup-complete-${f.id}`} className="text-xs text-[#F5691C] hover:underline">Mark done</button>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {kpis.map(([label, val]) => (
          <div key={label} data-testid={`crm-kpi-${label.toLowerCase().replace(/\s/g, '-')}`} className="bg-white rounded-lg border border-[#D7C6A9] p-4">
            <div className="text-xs text-neutral-500 uppercase tracking-wider">{label}</div>
            <div className="mono text-3xl font-extrabold text-neutral-900 mt-1.5">{val}</div>
          </div>
        ))}
      </div>
      <div className="bg-white rounded-lg border border-[#D7C6A9] p-5">
        <h2 className="font-heading text-base font-semibold text-neutral-900 mb-4">Lead Funnel</h2>
        <div className="space-y-3">
          {d.funnel.map((f) => (
            <div key={f.stage} className="flex items-center gap-3" data-testid={`crm-funnel-${f.stage}`}>
              <div className="w-40 shrink-0 text-sm text-neutral-700">{LABEL[f.stage] || f.stage}</div>
              <div className="flex-1 h-2.5 rounded-full bg-[#EEE9DE] overflow-hidden"><div className="h-full bg-[#F5691C] rounded-full transition-all" style={{ width: `${(f.count / max) * 100}%` }} /></div>
              <div className="mono text-sm text-neutral-700 w-8 text-right">{f.count}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
